import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import { RegularCard, Loading, GelContentRow, Introduction} from "cw-styleguide-react";
import Helmet from 'react-helmet';

class LandingView extends Component {

  render() {


    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('app.name')}</title>
          <meta name={'description'} content={this.props.t('app.description')}/>
        </Helmet>
          <h1>{this.props.data.title}</h1>
        <div className={"gel-lg-mb-40 gel-md-mb-40 gel-sm-mb-40"} >
        <Introduction>
          {this.props.data.description}
        </Introduction>
        </div>
          <GelContentRow>


            {this.props.data.aboutJobsTitles.map(function (job, index) {
              return <RegularCard
                key={index}
                width={25}
                link={{
                  to: '/' + job.slug
                }}
                alt={job.landingPageImage.alt}
                source={job.landingPageImage.src}
                title={job.name}
                classes={["gel-lg-mb-80","gel-md-mb-80","gel-sm-mb-80"]}
              />;
            }, this)}

          </GelContentRow>

      </Fragment>
    );
  }
}

export default withTranslation('local')(LandingView);
